import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubtopicMobile } from "../../../Pages/SubtopicMobile/ISubtopicMobile";

export const AddSubtopicMobileSlice = createSlice({
  name: "AddSubtopicMobileSlice",
  initialState: {} as IReduxState<ISubtopicMobile>,
  reducers: {
    addSubtopicMobile: (state, _: PayloadAction<ISubtopicMobile>) => {
      state.isLoading = true;
    },
    successaddSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddSubtopicMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSubtopicMobile,
  failureaddSubtopicMobile,
  successaddSubtopicMobile,
  clearAddSubtopicMobileResponse,
} = AddSubtopicMobileSlice.actions;

export default AddSubtopicMobileSlice.reducer;
